import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1 flex border-t overflow-auto xl:overflow-hidden flex-col xl:flex-row pt-4 xl:pt-0" }
const _hoisted_2 = { class: "xl:hidden md:px-8 px-3" }
const _hoisted_3 = ["value", "selected"]
const _hoisted_4 = { class: "border-r w-[250px] min-h-screen bg-white hidden xl:block text-xs text-gray-600 font-medium" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex-1 md:p-8 p-4 xl:overflow-auto" }

import { type Component, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useHasOrganizationPermission } from "shared/composables/organization";
import { Organization } from "shared/types/Organization";
import OrganizationTabGeneral from "@/views/organizations/components/OrganizationTabGeneral.vue";
import OrganizationTabProjects from "@/views/organizations/components/OrganizationTabProjects.vue";
import OrganizationTabUsers from "@/views/organizations/components/OrganizationTabUsers.vue";

type Tab = {
  name: string;
  label: string;
  content: Component;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationDetail',
  props: {
    organization: {},
    organizationsByParentId: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const route = useRoute();
const router = useRouter();

const hasOrganizationBasePermission = useHasOrganizationPermission(
  "organization_base",
  props.organization._id,
);

const tabs = computed(
  () =>
    [
      {
        name: "general",
        label: t("organizations.tab_general"),
        content: OrganizationTabGeneral,
      },
      hasOrganizationBasePermission.value && {
        name: "projects",
        label: t("organizations.projects"),
        content: OrganizationTabProjects,
      },
      hasOrganizationBasePermission.value && {
        name: "users",
        label: t("organizations.users"),
        content: OrganizationTabUsers,
      },
    ].filter((tab) => tab) as Tab[],
);

const currentTab = computed(
  () => tabs.value.find((tab) => tab.name === route.params.tab) || tabs.value[0],
);

const handleItemClick = (tabName: string) => {
  router.push({
    params: { ...route.params, tab: tabName },
    query: route.query,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        id: "tabs",
        name: "tabs",
        class: "w-auto oai-inputs",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (handleItemClick(($event?.target as HTMLInputElement)?.value as string)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
          return (_openBlock(), _createElementBlock("option", {
            key: tab.name,
            value: tab.name,
            selected: currentTab.value.name === tab.name
          }, _toDisplayString(tab.label), 9, _hoisted_3))
        }), 128))
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([
          'px-5 md:px-8 py-2 lg:p-5 border-l-4 cursor-pointer hover:text-oaiGray-900 border-b text-gray-600 font-medium text-xs flex items-center justify-between break-words',
          currentTab.value === tab ? 'border-l-yellow text-oaiGray-900 bg-gray-50' : '',
        ]),
          key: tab.name,
          onClick: ($event: any) => (handleItemClick(tab.name))
        }, _toDisplayString(tab.label), 11, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(currentTab.value.content), {
        organization: _ctx.organization,
        organizationsByParentId: _ctx.organizationsByParentId
      }, null, 8, ["organization", "organizationsByParentId"]))
    ])
  ]))
}
}

})